// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--RFB9A","content":"_93444fe79c--content--QsTlY","content--text":"_93444fe79c--content--text--ITcAg","image":"_93444fe79c--image--sNcnt"};